import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  popupIsOpened: false,
  currentPopup: '',
  data: {}
};

const popupsSlice = createSlice({
  name: 'popups',
  initialState,
  reducers: {
    popupOpen: {
      reducer: (state, action) => {
        state.popupIsOpened = true;
        state.currentPopup = action.payload.currentPopup;
        state.data = action.payload.data;
      },
      prepare: (currentPopup, data = {}) => ({ payload: { currentPopup, data } })
    },
    popupClosed: state => {
      state.popupIsOpened = false;
      state.currentPopup = '';
    }
  }
});

export const { popupOpen, popupClosed } = popupsSlice.actions;
export default popupsSlice.reducer;
